import styled from 'styled-components'


const ButtonAddNewSmallStyle = styled.button.attrs( props => ( { className: props.className } ) )`
    padding: 6px 12px;
    font-size: 14px;
    border-radius: var(--sp1x);
    -webkit-appearance: none;
    position: relative;
    background-color: var(--green);
    color: var(--white);
    transition: var(--trTime) ease-out;
    font-family: PopReg;
    font-weight: unset;
    border:none;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: var(--trTime) ease-out;

    &.red {
        background-color: var(--red);

        &:hover {
            background-color: #FF6174;
        }
    }

    svg {
        width: 10px;
        height: 10px;
        transition: var(--trTime) ease-out;
        margin-right: 10px;
    }

    &:hover {
        background-color: #9DE146;
    }
`
export default ButtonAddNewSmallStyle
